<template>
  <div>
    <ProductFinder
      v-model="products"

      :forceLoading="productId && !loaded"
      :remove-price="true"
      :uneditable-product-qty-skus="oldProductSkus"
    />
  </div>
</template>

<script>

import ProductFinder from "../../components/Product/ProductFinder/ProductFinder.vue"

import setupForm from "../../mixins/setupForm"

export default setupForm([], {
  props: {
    bundleProducts: Array,
    oldProductSkus: Array,
    productId: String,
  },
  components: {
    ProductFinder,
  },
  created() {
    if (this.bundleProducts.length) {
      this.retrieveProducts()
    }
  },
  data() {
    return {
      products: this.bundleProducts || [],
      loaded: false,
    }
  },
  methods: {
    async retrieveProducts() {
      this.products = await Promise.all(
        this.bundleProducts.map(async ({sku, qty}) => {
          const product = (await this.axios.get(`/api/products/${sku}`)).data
          product.qty = qty
          return product
        })
      )

      this.loaded = true
    },
  },
  watch: {
    products(products) {
      this.$emit("set-products", products)
    },
    bundleProducts(products) {
      this.products = products
      !this.loaded && this.retrieveProducts()
    },
  },
})

</script>
